import React, { useState, useEffect } from "react";
import { externalgetApi } from "../../services/external/externalApis";
import { EMPLOYEE_API_04 } from "../../api/ApiModel";
import { useSelector, useDispatch } from "react-redux";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import { Typography, Divider } from "@mui/material";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import AppBar from "@mui/material/AppBar";
import Avatar from "@mui/material/Avatar";
import { BASEURL } from "../../config/Config";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";

const MyProfile = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);

  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, USERNAME } = SYS_USER.USER_PARAM || {};

  const [profileData, setProfileData] = useState(null);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [error, setError] = useState(null);

  // API call
  // API call
  useEffect(() => {
    const fetchProfileData = async () => {
      // if (!COMPCODE || !USERNAME) {
      //   console.error("COMPCODE or USERNAME is not defined.");
      //   return;
      // }

      try {
        const params = {
          COMPCODE,
          USERNAME,
          STS: CON_STATUS_ACTIVE,
        };

        const response = await externalgetApi(EMPLOYEE_API_04, "GET", params);
        console.log("API Response:", response); // Check the API response
        setProfileData(response[0]); // Access the first element of the array
        setDataLoaded(true);
      } catch (error) {
        console.error("Error fetching profile data:", error);
        setError(error);
      } finally {
        setDataLoaded(true);
      }
    };

    fetchProfileData();
  }, []); // Include COMPCODE and USERNAME as dependencies

  if (error) {
    return <Typography color="error">Error loading profile data</Typography>;
  }

  // const profileImage = profileData?.EMPIMAGE
  //   ? `${BASEURL}${profileData.EMPIMAGE.replace("~", "")}`
  //   : "/path/to/default-image.jpg";

  const profileImage = profileData?.EMPIMAGE
    ? `${profileData.EMPIMAGE}`
    : "/path/to/default-image.jpg";

  const gotToPage = () => {
    navigate("/myprofile");
  };

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Employee</Link>
                <Link underline="none">MyProfile</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack2,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                {/* <Button
                  onClick={gotToPage}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                >
                  Back
                </Button> */}
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={{ ...styles.mp_box_container }}>
        <Grid container spacing={4}>
          {/* Avatar Section */}
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <Box
              sx={{
                ...styles.cb_col_1,
                maxHeight: "100vh",
                overflowY: "auto",
                bgcolor: theme.palette.background.paper,
                borderRadius: "8px",
                boxShadow: 3,
                minHeight: "40vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                p: 3,
                // width: "100%",
                transition: "box-shadow 0.3s",
                "&:hover": { boxShadow: 6 },
                background: `linear-gradient(135deg, ${theme.palette.background.default} 30%, ${theme.palette.background.paper} 100%)`,
              }}
            >
              <Avatar
                alt={profileData ? profileData.FULLNAME : "Profile Picture"}
                src={profileImage}
                sx={{
                  width: 150,
                  height: 150,
                  mt: 2,
                  border: `3px solid ${theme.palette.primary.main}`,
                  boxShadow: 3,
                  transition: "transform 0.3s",
                  "&:hover": { transform: "scale(1.1)" },
                }}
              />
              <Typography
                variant="h6"
                sx={{
                  mt: 2,
                  fontWeight: "bold",
                  color: theme.palette.text.primary,
                }}
              >
                {profileData
                  ? ` ${profileData.FIRSTNAME} ${profileData.LASTNAME}`
                  : "Loading..."}
              </Typography>
              <Typography
                variant="subtitle1"
                color={theme.palette.text.secondary}
                sx={{ textAlign: "center" }}
              >
                {profileData ? profileData.USERNAME : "Loading..."}
              </Typography>
            </Box>
          </Grid>

          {/* Profile Details Section */}
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <Box
              sx={{
                ...styles.cb_col_1,
                maxHeight: "100vh",
                overflowY: "auto",
                bgcolor: theme.palette.background.paper,
                borderRadius: "8px",
                boxShadow: 3,
                minHeight: "40vh",
                p: 3,
                // width: "100%",
                transition: "box-shadow 0.3s",
                "&:hover": { boxShadow: 6 },
                background: `linear-gradient(135deg, ${theme.palette.background.default} 30%, ${theme.palette.background.paper} 100%)`,
              }}
            >
              {/* Fixed "My Profile" title */}
              <Typography
                variant="h6"
                sx={{
                  mb: 2,
                  fontWeight: "bold",
                  color: theme.palette.primary.main,
                  position: "sticky", // Make it sticky
                  top: 0, // Fix it to the top
                  zIndex: 1, // Ensure it stays on top when scrolling
                  backgroundColor: theme.palette.background.paper, // Add background color for better visibility
                  padding: "8px 8px", // Padding around the text
                  borderRadius: 1,
                  boxShadow: 1,
                }}
              >
                My Profile
              </Typography>
              <Box
                sx={{
                  maxHeight: "62vh",
                  overflowY: "auto",
                  // pr: 2,
                }}
              >
                {/* Dynamic Profile Details */}
                {[
                  {
                    label: "First Name",
                    value: profileData
                      ? ` ${profileData.FIRSTNAME}`
                      : "Loading...",
                  },
                  {
                    label: "Last Name",
                    value: profileData
                      ? ` ${profileData.LASTNAME}`
                      : "Loading...",
                  },
                  {
                    label: "Username",
                    value: profileData ? profileData.USERNAME : "Loading...",
                  },
                ].map((item, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      py: 1,
                      px: 1,
                      mt: 2,
                      backgroundColor:
                        index % 2 === 0
                          ? theme.palette.background.default // Color for even rows
                          : theme.palette.action.hover, // Color for odd rows
                      borderRadius: "4px", // Optional, to make it visually smoother
                      border: `1px solid ${theme.palette.stroke.main}`,
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: "bold",
                        color: theme.palette.text.secondary,
                      }}
                    >
                      {item.label}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: theme.palette.text.primary,
                        fontStyle: "italic",
                      }}
                    >
                      {item.value}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default MyProfile;
